import type {
  SpectralWorkspaceSettings,
  SpectralWorkspaceSnapshot,
  CustomTimeSegment,
} from '../types';

export const createDefaultWorkspaceSettings =
  (): SpectralWorkspaceSettings => ({
    activeViewId: 'full',
    trendStart: null,
    trendEnd: null,
    selectedFeature: 'HR',
    trendNormalizationEnabled: false,
    trendLowPassEnabled: false,
    showOverlaySessions: false,
    selectedOverlaySessionIds: [],
    selectedSpectraSessionId: null,
    spectraStart: null,
    spectraEnd: null,
    spectraLogScale: false,
  });

export const buildEmptyWorkspaceSnapshot = ({
  name,
  description,
  author,
}: {
  name: string;
  description?: string;
  author: string;
}): SpectralWorkspaceSnapshot => {
  const now = new Date().toISOString();

  return {
    analysisId: '',
    name,
    description,
    author,
    createdAt: now,
    updatedAt: now,
    activeSessionGroupId: null,
    customSegments: [],
    workspace: createDefaultWorkspaceSettings(),
  };
};

export const isSpectralWorkspaceSnapshot = (
  value: unknown
): value is SpectralWorkspaceSnapshot =>
  typeof value === 'object' &&
  value != null &&
  'workspace' in value &&
  !('selectedSessions' in value);

export const buildSnapshotFromWorkspace = ({
  analysisId,
  name,
  description,
  author,
  createdAt,
  activeSessionGroupId,
  customSegments,
  workspace,
}: {
  analysisId: string;
  name: string;
  description?: string;
  author: string;
  createdAt: string;
  activeSessionGroupId: string | null;
  customSegments: CustomTimeSegment[];
  workspace: SpectralWorkspaceSettings;
}): SpectralWorkspaceSnapshot => ({
  analysisId,
  name,
  description,
  author,
  createdAt,
  updatedAt: new Date().toISOString(),
  activeSessionGroupId,
  customSegments,
  workspace,
});
